module.exports = "/images/br.svg?059d20942471f0219d3cd53c71f63d35";